import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgMinus from '../../svg/minus.svg'
import { IconProps } from '../icon-props'

const MinusIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgMinus
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-minus', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default MinusIcon
